import * as React from "react";
import { useState, useEffect} from "react"
import PageContainerWide from "../core/PageContainerWide";
import Breadcrumbs from "../core/Breadcrumbs";
import { jfetch } from "../../utils";
import { useParams, Link, useHistory } from "react-router-dom";
import QuoteSummary from "./QuoteSummary"
import QuoteForm from "./QuoteForm"
import Sticky from 'react-sticky-el';
import useQuote from '../../hooks/useQuote'
import useQuery from "../../hooks/useQuery";

interface IProps {
  userContext:any;
  services:any;
  products:any;
  charges:any;
  productCategories:any;
  serviceCategories:any;
  chargeCategories:any;
  projectServiceCategories:any;
  updateService: Function;
  updateProduct: Function;
  updateCharge: Function;
  company:string;
  contact:string;
  email:string;
  notes:string;
  sold:boolean;
  isHAAS:boolean;
  setCompany:Function;
  setContact:Function;
  setEmail:Function;
  setNotes:Function;
  setSold:Function;
  setHAAS:Function;
  servicesTotal:number;
  serviceProfit:number;
  productsTotal:number;
  productProfit:number;
  chargesTotal:number;
  chargeProfit:number;
  monthlyRevenue:number;
  monthlyProfit:number;
  dueAmount:number;
  monthlyExpense:number;
  setServices: Function;
  setProducts: Function;
  setCharges: Function;
  withHAAS:number;
  withoutHAAS:number;  
  LLGM:number;
  modifier:number;
  setModifier:Function;  
  burdenRate:number;
  billRate:number;
  ROI:number;
  setBurdenRate:Function;
  setBillRate:Function;
  setROI:Function;
  contractTerm: number;
  setContractTerm: Function;  
  projectServices:any;
  setProjectServices:Function;
  updateProjectService:Function;
  projectHours:number;
  projectLaborRevenue:number;
  projectLaborExpense:number;  
  chargesOnlyTotal:number;
}

function QuoteShow(props:IProps){

  const { calculator_id }:any = useParams()
  const { quote_id }:any = useParams()
  const { setSoldString, setCwCompany, setCwId, cwCompany, cwId } = useQuote()
  let query = useQuery();

  useEffect(() => {
      //init set default services, products & charges
      jfetch
      .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes/${quote_id}`)
      .then((resp) => {
        let quote = resp.quote
        props.setServices(resp.meta.sorted_services, false)
        props.setProducts(resp.meta.sorted_products)
        props.setCharges(resp.meta.sorted_charges)
        props.setProjectServices(resp.meta.sorted_project_services)
        props.setCompany(quote.company)
        props.setContact(quote.contact)
        props.setNotes(quote.notes)
        props.setEmail(quote.email)
        props.setSold(quote.sold)
        props.setHAAS(quote.is_haas)
        props.setModifier(quote.modifier)
        setCwCompany(quote.company_name)
        setCwId(quote.company_id)
        if(quote.sold == null){
          setSoldString('')
        }
        else{
          if(quote.sold){
            setSoldString('1')
          }
          else {
            setSoldString('0')
          }
        }        
      })
    }, [])
  
  

  return (
    <div className="quote-new">
      <PageContainerWide>
        <Breadcrumbs
          crumbs={[
            {
              label: "Pricing Quote Dashboard",
              route: "/quote_calculator",
              routerLink: true,
            },
            {
              label: "Quotes",
              routerLink: true,
              route: `/quote_calculator/${calculator_id}/quotes/`
            },            
            { label: `View Quote` },
          ]}
        /> 
        <div className="row">
          <div className="col-lg-9">
            <div className="alert alert-warning" role="alert">
              * This quote is in read only mode, &nbsp;
              <Link to={`/quote_calculator/${calculator_id}/quote_edit/${quote_id}/`}> 
                click here to edit
              </Link>.
            </div>
          </div>
          <QuoteForm 
            disabled={true}
            services={props.services}
            products={props.products}
            charges={props.charges}
            productCategories={props.productCategories}
            serviceCategories={props.serviceCategories}
            chargeCategories={props.chargeCategories}
            projectServiceCategories={props.projectServiceCategories}
            updateService={props.updateService}
            updateProduct={props.updateProduct}
            updateCharge={props.updateCharge}
            company={props.company}
            contact={props.contact}
            email={props.email}
            notes={props.notes}
            sold={props.sold}
            isHAAS={props.isHAAS}
            setCompany={props.setCompany}
            setContact={props.setContact}
            setEmail={props.setEmail}
            setNotes={props.setNotes}
            setSold={props.setSold}
            setHAAS={props.setHAAS}
            userContext={props.userContext}
            burdenRate={props.burdenRate}
            billRate={props.billRate}
            ROI={props.ROI}
            setBurdenRate={props.setBurdenRate}
            setBillRate={props.setBillRate} 
            setROI={props.setROI}
            contractTerm={props.contractTerm}
            setContractTerm={(val) => props.setContractTerm(val)}            
            projectServices={props.projectServices}
            updateProjectService={props.updateProjectService}
            projectHours={props.projectHours}
            projectLaborRevenue={props.projectLaborRevenue}
            projectLaborExpense={props.projectLaborExpense} 
            servicesTotal={props.servicesTotal} 
            productsTotal={props.productsTotal} 
            chargesTotal={props.chargesTotal}       
            chargesOnlyTotal={props.chargesOnlyTotal}        
            cwCompany={cwCompany}
            cwId={cwId}     
          />
          <div className="col-lg-3">
            <Sticky>
              <div style={{paddingTop:'67px'}}>
                <h4 style={{color:'black'}}>Quote: {props.company}</h4>
                <div className="row">
                  <div className="col-lg-12">
                    <QuoteSummary 
                      servicesTotal={props.servicesTotal} 
                      serviceProfit={props.serviceProfit} 
                      productsTotal={props.productsTotal} 
                      productProfit={props.productProfit} 
                      chargesTotal={props.chargesTotal} 
                      chargeProfit={props.chargeProfit}
                      monthlyRevenue={props.monthlyRevenue} 
                      monthlyProfit={props.monthlyProfit}
                      dueAmount={props.dueAmount}
                      withHAAS={props.withHAAS}
                      withoutHAAS={props.withoutHAAS}    
                      LLGM={props.LLGM}
                      modifier={props.modifier}
                      setModifier={props.setModifier}
                      burdenRate={props.burdenRate}
                      billRate={props.billRate}
                    />
                  </div>
                </div>
              </div>
            </Sticky>          
          </div>
        </div>      
      </PageContainerWide>
    </div>
  )
}

export default QuoteShow


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteShow.tsx